import React from "react";

function Button(props) {
  return (
    <button
      value={props.value}
      onClick={props.onClick}
      className="card-link btn btn-primary"
    >
      {props.label}
    </button>
  );
}

export default Button;
